angular.module('lsnBase.deprecated.models')
  .factory('BonusMalusNewModel', ['LsnBonusMalusNewModelV1',
    function(LsnBonusMalusNewModelV1) {
      return LsnBonusMalusNewModelV1;
    }
  ]);